/**
 * Copyright Mántum All Rights Reserved.
 */
import debug from 'debug';
import request from '@mantum/kanela-request';
import { source } from '@mantum/kanela';

const logger = debug('kanela:request');

type Option = {
    url: string;
    args: {
        body: Record<string, unknown>;
        headers?: Record<string, string>;
        method: string;
        namespace?: string;
    };
};

export default function <T>(option: Option): Promise<T> {
    return new Promise((resolve, reject) => {
        logger('fetch %s', option.url);
        const response = request.fetch(option.url, {
            method: option.args.method,
            body: option.args.body,
            headers: option.args.headers
        });

        response.then((values: unknown[]) => {
            logger('response request %o', values);
            resolve(source.extract(values, option.args.namespace));
        });

        response.catch((error: unknown) => {
            logger('error request %o', error);
            reject(error);
        });
    });
}
